<template>
  <div class="container">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <span class="md-title">{{$t('ticket.list.title')}}</span>
      </div>
      <div class="md-layout-item">
        <md-toolbar class="md-transparent">
          <div class="md-toolbar-row">
            <div>
              <md-button
              :class="{'md-primary': tabActive === 'TICKETS', 'md-simple': tabActive !== 'TICKETS'}"
              @click="tabActive = 'TICKETS'">{{$t("ticket.list.tabs.ticket.title")}}</md-button>
              <md-tooltip md-direction="bottom">{{$t("ticket.list.tabs.ticket.tooltip")}}</md-tooltip>
            </div>
            <div>
              <md-button 
              :class="{'md-primary': tabActive === 'SUBSCRIPTIONS', 'md-simple': tabActive !== 'SUBSCRIPTIONS'}"
              @click="tabActive = 'SUBSCRIPTIONS'">{{$t("ticket.list.tabs.subscriptions.title")}}</md-button>
              <md-tooltip md-direction="bottom">{{$t("ticket.list.tabs.subscriptions.tooltip")}}</md-tooltip>
            </div>
          </div>
        </md-toolbar>
        <!-- List tickets -->
        <template v-if="tabActive === 'TICKETS'">
          <list-tickets></list-tickets>
        </template>
        <!-- List subscriptions -->
        <template v-if="tabActive === 'SUBSCRIPTIONS'">
          <list-subscriptions></list-subscriptions>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import ListTickets from '@/pages/Ticketera/List/Tickets'
import ListSubscriptions from '@/pages/Ticketera/List/Subscriptions'

export default {
  components: {
    ListTickets,
    ListSubscriptions
  },
  data() {
    return {
      tabActive: "TICKETS"
    }
  }
}
</script>